

const messages = {
    en: {
        message: 'test',
        menu: {
            home: 'HOME'
        },
    },
};

export default messages
